/**
 * Convert a date-picker value (YYYY-MM-DD) into the invite expiry datetime
 * stored by the API. Invites expire at hour 22 on the selected local date,
 * persisted as a timezone-naive UTC string (`YYYY-MM-DDTHH:mm:ss`).
 */
export function expiryDateToApiDatetime(datePickerValue: string): string {
  const date = new Date(datePickerValue);
  date.setHours(22);
  const utcDatetime = new Date(
    date.toLocaleString("en-US", {
      timeZone: "UTC",
    })
  );
  return utcDatetime.toISOString().slice(0, 19);
}

/**
 * Convert a stored invite expiry datetime back to a date-picker value (YYYY-MM-DD).
 */
export function expiryDateFromApiDatetime(apiDatetime: string): string {
  const expiryDate = new Date(apiDatetime + "Z");
  return expiryDate.toISOString().slice(0, 10);
}

/** Earliest date the expiry picker should allow, as an ISO timestamp. */
export function allowedMinExpiryDate(): string {
  return new Date().toISOString();
}

/**
 * Format a stored invite expiry datetime for display in the clinic UI.
 */
export function formatExpiryDateForDisplay(
  apiDatetime: string,
  locale: string
): string {
  const date = new Date(apiDatetime + "Z");
  return date.toLocaleDateString(locale, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}
